import posthtml from 'posthtml/lib';
export const modifyPreviewText = (mjml, preheader) => {
  const hasPreviewTag = mjml.includes('<mj-preview');
  const insertPreviewText = tree => {
    tree.match({
      tag: 'mj-preview'
    }, node => {
      node.content = [preheader];
      return node;
    });
  };
  const adPreviewTag = tree => {
    tree.match({
      tag: 'mj-head'
    }, node => {
      if (!node.content) {
        node.content = [];
      }
      node.content.push({
        tag: 'mj-preview',
        content: [preheader]
      });
      return node;
    });
  };
  const processingFn = hasPreviewTag ? insertPreviewText : adPreviewTag;
  return posthtml([processingFn]).process(mjml, {
    sync: true,
    xmlMode: true
  }).html;
};
//# sourceMappingURL=modify-preview-text.js.map